export default class ShopifyNewsletter extends HTMLElement {
  email: string = ''

  static get observedAttributes() {
    return ['email']
  }

  constructor() {
    super()

    this.email = this.getAttribute('email') || ''
  }

  attributeChangedCallback(name: string, oldValue: any, newValue: any) {
    if (oldValue === newValue) {
      return
    }

    if (name === 'email') {
      this.email = newValue
    }
  }
}

customElements.define('shopify-newsletter', ShopifyNewsletter);
